import { useState, Fragment } from 'react'
import { useGetExercises } from 'redux/customHooks/useGetExercises'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid'

import ContentFrame from 'components/Frame/ContentFrame'
import ExerciseProgressionObject from 'components/ProgramGenerator/ExerciseProgressionObject'

export default function ExerciseProgressionConfig({ exerciseProgressionConfig }) {

    const progressionTypeToggleOptions = [
        {
            value: 'all',
            text: 'All',
        },
        {
            value: 'static',
            text: 'Static',
        },
        {
            value: 'single-category',
            text: 'Single Category',
        },
        {
            value: 'multi-category',
            text: 'Multi Category',
        },
        {
            value: 'single-category-assessment-placement',
            text: 'Single Category Assessment Placement',
        },
        {
            value: 'multi-category-assessment-weakness-override',
            text: 'Multi Category Assessment Weakness Override',
        }
    ]

    const { exercises } = useGetExercises()
    
    const [progressionTypeToggle, setProgressionTypeToggle] = useState('all')
    const [isExpanded, setIsExpanded] = useState(false)

    // console.log(exerciseProgressionConfig)

    if (
        exercises.length === 0 
        || exerciseProgressionConfig === undefined 
        || exerciseProgressionConfig === null
    ){
        return <></>
    }

    return (
        <ContentFrame className='p-4 space-y-4'>
            <div 
                className="flex items-center justify-center gap-2 cursor-pointer w-full"
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <h1>Exercise Progressions</h1>

                <div className="text-gray-600 hover:text-gray-800 cursor-pointer">
                    {isExpanded ? <ChevronUpIcon className='w-6 h-6' /> : <ChevronDownIcon className='w-6 h-6' />}
                </div>
            </div>

            {isExpanded && (
                <>
                    <div className="flex border border-gray-600 divide-x divide-gray-600 rounded-xl text-center text-xs truncate overflow-hidden">
                        {progressionTypeToggleOptions.map((option, index) => (
                            <div
                                key={index}
                                className={`
                                    p-2 flex-1 cursor-pointer text-xs
                                    ${option.value === progressionTypeToggle ? 'bg-white' : 'bg-gray-100'}
                                `}
                                onClick={() => setProgressionTypeToggle(option.value)}
                            >
                                {option.text}
                            </div>
                        ))}
                    </div>

                    {Object.keys(exerciseProgressionConfig).filter(key => key.toLowerCase().includes('strength')).map((key) => (
                        <Fragment key={key}>
                            <div className="text-xl font-semibold">
                                {exerciseProgressionConfig[key].name}
                            </div>

                            <div className="w-[1600px] text-center space-y-1 overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
                                {exerciseProgressionConfig[key].phases.map((phase, phaseIndex) => (
                                    <Fragment key={phaseIndex}>
                                        {phase.slots.map((exerciseSlot, exerciseSlotIndex) => (
                                            <Fragment key={exerciseSlotIndex}>
                                                {(
                                                    progressionTypeToggle === 'all' 
                                                    || (progressionTypeToggle === 'static' && exerciseSlot.progressionType === 'static')
                                                    || (progressionTypeToggle === 'single-category' && exerciseSlot.progressionType === 'single-category') 
                                                    || (progressionTypeToggle === 'single-category-assessment-placement' && exerciseSlot.progressionType === 'single-category-assessment-placement')
                                                    || (progressionTypeToggle === 'multi-category' && exerciseSlot.progressionType === 'multi-category')
                                                    || (progressionTypeToggle === 'multi-category-assessment-weakness-override' && exerciseSlot.progressionType === 'multi-category-assessment-weakness-override')
                                                ) && (
                                                    <div className="flex items-center gap-x-1">
                                                        <div className="relative group">
                                                            <div className="h-32 w-40 p-2 rounded-xl flex flex-col items-center justify-center cursor-default bg-gray-100">
                                                                <div>{phase.name} Slot {exerciseSlotIndex + 1}</div>
                                                                <div className='text-sm text-gray-500'>{exerciseSlot.progressionType}</div>
                                                            </div>

                                                            <div className="hidden group-hover:block absolute left-full top-1/2 z-30 ml-4 -translate-y-1/2">
                                                                <div className="max-h-80 max-w-[480px] overflow-auto rounded-md bg-black/90 text-xs text-white p-2 shadow-lg whitespace-pre text-left">
                                                                    {JSON.stringify(exerciseSlot.progressionFilters, null, 8)}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* <pre>{JSON.stringify(exerciseSlot.clampedExerciseProgressionConfig, null, 2)}</pre> */}

                                                        {exerciseSlot.clampedExerciseProgressionConfig.map((progressionExercise, progressionExerciseIndex) => (
                                                            <div key={progressionExerciseIndex}>
                                                                <ExerciseProgressionObject
                                                                    exercises={exercises}
                                                                    exercise={progressionExercise}
                                                                />
                                                            </div> 
                                                        ))}
                                                    </div>
                                                )}
                                            </Fragment>
                                        ))}
                                    </Fragment>
                                ))}
                            </div>
                        </Fragment>
                    ))}
                </>
            )}
        </ContentFrame>
    )
}